import { schema } from 'normalizr';

export const messageSchema = new schema.Entity('message');
